import { useState } from "react"
import { FIRST_PAGE, PAGE_COUNT_DELTA } from "../constants"
import {
	PaginationLocalProps,
	PaginatorConfigProps,
	UsePagination,
} from "../interfaces"

export const usePaginationLocal = <T>(
	props: PaginationLocalProps<T>
): UsePagination<T> => {
	const { itemsPerPage, data: rawData, initialPage = FIRST_PAGE } = props

	const data = rawData ?? []
	const [itemOffset, setItemOffset] = useState(FIRST_PAGE)
	const [currentPage, setCurrentPage] = useState(initialPage)
	const endOffset = itemOffset + itemsPerPage
	const currentData = data.slice(itemOffset, endOffset)
	const pageCount = Math.ceil(data.length / itemsPerPage)

	const setSelectPage = (page: number) => {
		const newOffset = (page * itemsPerPage) % data.length || 0
		setItemOffset(newOffset)
		setCurrentPage(page)
	}

	const handlePageClick = (event: { selected: number }) => {
		setSelectPage(event.selected)
	}

	const getPaginatorProps = (): PaginatorConfigProps => ({
		pageCount,
		forcePage: currentPage,
		onPageChange: handlePageClick,
	})

	const isCurrentPageFirstOrLastPage = (): boolean => {
		const lastPage = pageCount - PAGE_COUNT_DELTA
		return currentPage === FIRST_PAGE || currentPage === lastPage
	}

	return {
		itemsPerPage,
		currentData,
		currentPage,
		pageCount,
		isCurrentPageFirstOrLastPage,
		handlePageClick,
		getPaginatorProps,
		setSelectPage,
	}
}
